module.exports = __webpack_public_path__ + "static/media/hero-bg.0a8f0dff.jpg";